import { Injectable } from '@angular/core';
import { SpecificationVersionModification } from 'app/modules/shared/model/specification-version-modification';
import { ApiProxyService } from 'app/modules/shared/services/api-proxy.service';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ModificationInfoService {

  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

  public getAllModification(specificationVersionId: number): Observable<SpecificationVersionModification[]> {
    return this.apiProxy.get<SpecificationVersionModification[]>(`${this.configService.apiUrl}SpecificationVersionModification/AllModificationInfo/${specificationVersionId}`);
  }

  public getLastModification(specificationVersionId: number) {
    return this.apiProxy.get<SpecificationVersionModification>(`${this.configService.apiUrl}SpecificationVersionModification/GetLastModification/${specificationVersionId}`);
  }
}